// extracted by mini-css-extract-plugin
export default {"hasSettingsDropdown":"Dishes_hasSettingsDropdown__EMWsQ","toolbar":"Dishes_toolbar__Ulvos","placeHolderShimmer":"Dishes_placeHolderShimmer__9TaNo"};